import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=3d52f520&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d52f520')) {
      api.createRecord('3d52f520', component.options)
    } else {
      api.reload('3d52f520', component.options)
    }
    module.hot.accept("./Aside.vue?vue&type=template&id=3d52f520&", function () {
      api.rerender('3d52f520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/saas/layoutSystem/Aside.vue"
export default component.exports